import { DomainName } from 'types/Marketing/SGLLinkGenerator.types'

import { NameDto } from '../../Common/Types'
import { CountryPreferenceProduct } from './CountryPreferenceProduct'

export interface CountryPreferenceCompanyDto {
  company: {
    shortName: string | null
    name: string | null
    id: number
    tickmillPublicDomain: DomainName | null
  }
  forcedLink: string
  expedited: boolean
  sumsubVerificationRequired: boolean
  onboardingFlowType: NameDto
  ongoingScreeningEnabled: boolean
  isPreferred: boolean
  isHidden: boolean
  products: CountryPreferenceProduct[]
}

export interface CountryPreferenceDto {
  country: {
    id: string | null
    name: string | null
    isEuropeanUnion: boolean
  }
  language: {
    id: string | null
    name: string | null
  }
  currency: {
    id: string | null
    name: string | null
  }
  phoneVerificationRequired: boolean
  phoneVerificationProvider: NameDto
  companies: CountryPreferenceCompanyDto[]
  twoFactorAuthVerificationProviders: [
    {
      twoFactorVerificationProvider: {
        id: PhoneVerificationProvider
        name: 'Email' | 'None' | 'SMS'
      }
      twoFactorAuthType: {
        id: 1 | 2 | 3
        name: 'Email' | 'SMS' | 'Google'
      }
    },
  ]
}

export enum PhoneVerificationProvider {
  NoProvider = 1,
  VONAGE = 2,
  TWILIO = 3,
}

export enum TwoFactorVerificationProvider {
  Email = 1,
  SMS = 2,
  Google = 3,
}

export const isPhoneVerificationProviderNone = (value: number): boolean => {
  return value === PhoneVerificationProvider.NoProvider
}
